import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { ReporteInventarioRoutingModule } from './reporte-inventario-routing.module';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';
import { PipesModule } from '../../pipes/pipes.module';

import { ReporteArticuloComponent } from './articulo/lista.component';
import { EscasoComponent } from './escaso/lista.component'; 
import { InventariadoComponent } from './inventariado/lista.component';
import { InventarioComponent } from './inventario/lista.component';
import { ResagadoComponent } from './resagado/lista.component';
import { PopularComponent } from './popular/lista.component';

import { AuthService } from '../../auth.service';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule }  from '../../crud/crud.module';
//fin crud
import { NgSelect2Module } from 'ng-select2';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReporteInventarioRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    MenuModule, 
    ParcialModule,
    CrudModule,
    NgSelect2Module,
    PipesModule
  ],
  declarations: [ 
    ReporteArticuloComponent,
    EscasoComponent,
    InventariadoComponent,
    InventarioComponent,
    ResagadoComponent,
    PopularComponent
  ],
  providers: [ AuthService, CrudService ]
})
export class ReporteInventarioModule { }